var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FrameHeader',[_c('ActionButton',{staticClass:"left",attrs:{"icon":"bars"},on:{"click":_vm.openMobileNavBar}}),_c('section',{staticClass:"header-caption"},[_c('FrameLogo')],1),_c('ActionButton',{staticClass:"right",attrs:{"icon":"search"},on:{"click":_vm.handlerSearch}}),_c('AppMobileNavBar',{ref:"mobileNavBar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }